import { ButtonGroup, ToggleButton } from 'react-bootstrap'
import { useState, useEffect } from 'react'
import parse from 'html-react-parser'

/*
 * QuestionSingleChoice component. Used for displaying Yes/No or True/False options
 */
export default function QuestionSingleChoice({
  question,
  handleSaveResponse,
  defaultValue
}) {
  const [selection, setSelection] = useState(defaultValue)

  useEffect(() => {
    // Silence is golden :)
  }, [defaultValue, selection])

  return (
    question && (
      <ButtonGroup aria-label={question._question}>
        {question._answerData.map(answer => (
          <ToggleButton
            variant='light'
            key={answer._answer}
            name={'question'}
            onClick={_ => {
              handleSaveResponse(answer._answer)
              setSelection(answer._answer)
            }}
            value={answer._answer}
            type='radio'
            checked={answer._answer === selection}
            active={answer._answer === selection}
          >
            {answer._html ? parse(answer._answer) : answer._answer}
          </ToggleButton>
        ))}
      </ButtonGroup>
    )
  )
}
